"use client";
import Script from "next/script";

const isProduction = process.env.NODE_ENV === "production";

export function OrkaScript() {
	if (!isProduction) {
		return null;
	}

	return (
		<Script
			id="orka-chat-widget"
			strategy="afterInteractive"
			dangerouslySetInnerHTML={{
				__html: `
          window.ORKA_APP_ID="680b22a666ead041c1047bcc";
          (function(){
            d=document;
            s=d.createElement("script");
            s.src="//widget.orka.chat/app.js";
            s.async=1;
            d.getElementsByTagName("head")[0].appendChild(s);
          })();
        `,
			}}
		/>
	);
}

// declare global {
// 	interface Window {
// 		ORKA_APP_ID?: string; // Make optional or ensure it's always set
// 	}
// }

// export function OrkaScript() {
// 	return (
// 		<Script
// 			id="orka-chat-widget"
// 			strategy="afterInteractive"
// 			src="//widget.orka.chat/app.js"
// 			onLoad={() => {
// 				window.ORKA_APP_ID = "680b22a666ead041c1047bcc";
// 			}}
// 		/>
// 	);
// }
